import { DIRECT_DEBIT_ERROR_SHOW, APPROVAL_POPUP_CLOSE, APPROVAL_POPUP_SHOW } from './CAPageConstants';

export const isApprovalPopupVisible = (state = true, action) => {
    switch (action.type) {
        case APPROVAL_POPUP_CLOSE:
            return false;
        case APPROVAL_POPUP_SHOW:
            return true;
        default:
            return state;
    }
};

export default (state = {
    showDirectDebitError: false
}, action) => {
    switch (action.type) {
        case DIRECT_DEBIT_ERROR_SHOW:
            return Object.assign({}, state, {
                showDirectDebitError: action.payload
            });
        default:
            return state;
    }
};
